// **The asterisk MUI puts after a required field's label.**
//
// Two characters, and this repo got them wrong in three different places at
// three different times: `FormLabel` renders them as one element with
// `children: [U+2009, '*']` (`FormLabel.js:124-128`), so the separator is
// U+2009 THIN SPACE — not U+0020, which is 2.25px wider at 16px and 1.69px at
// 12px — and it sits *inside* the decorative element.
//
// Both halves are load-bearing:
//
//   - the width, because it is the donor's own glyph metric, and it is
//     measured twice over: the shrunk label's ellipsis budget, and the width of
//     the hole in the outline. MUI renders these same two characters in two
//     places — `FormLabel` draws them after the label, and `OutlinedInput`
//     re-injects them into the legend that cuts the gap when the `FormControl`
//     is required (`OutlinedInput.js:224-228`). So this component is rendered
//     from both the label and `FieldNotch`, and a space of the wrong width
//     moves the label's text and the border's gap out of step;
//   - the nesting, because U+2009 is not HTML whitespace and the
//     accessible-name algorithm therefore does not trim it. Parked outside the
//     `aria-hidden` span it stays in the name a screen reader announces — and a
//     field label's name is the field's.
//
// One element so the next correction lands everywhere at once.
export function RequiredAsterisk() {
  return <span aria-hidden="true">{"\u2009*"}</span>;
}
